import React, { useState } from 'react';
import { Button, Modal, InputNumber } from 'antd';
import { DeliveryItem } from '../../../../../core-module/models/OrderHistory/OrderHistory';

interface Props {
  item: DeliveryItem;
  onUpdateQuantity: (item: DeliveryItem, newQuantity: number) => Promise<void>;
  onCancelItem: (item: DeliveryItem) => Promise<void>;
}

const OrderEditItemFormComponent: React.FC<Props> = ({ item, onCancelItem, onUpdateQuantity }) => {
  const [isUpdateQuantityModalVisible, setIsUpdateQuantityModalVisible] = useState(false);
  const [isCancelModalVisible, setIsCancelModalVisible] = useState(false);
  const [newQuantity, setNewQuantity] = useState<number>(item.quantity);
  const [isSaving, setIsSaving] = useState(false);

  if (item.parentSalesOrderItemId || item.rejectionStatus === 'CompletelyRejected') {
    return null;
  }

  const showUpdateQuantityModal = () => {
    setNewQuantity(item.quantity);
    setIsUpdateQuantityModalVisible(true);
  };

  const handleUpdateQuantityOk = async () => {
    setIsSaving(true);
    await onUpdateQuantity(item, newQuantity);
    setIsUpdateQuantityModalVisible(false);
    setIsSaving(false);
  };

  const showCancelModal = () => {
    setIsCancelModalVisible(true);
  };

  const handleCancelOk = async () => {
    setIsSaving(true);
    await onCancelItem(item);
    setIsCancelModalVisible(false);
    setIsSaving(false);
  };

  return (
    <div style={{ marginBottom: '1em' }}>
      <p style={{ marginBottom: 0, marginTop: '1em' }}>
        <strong>
          {item.quantity}x {item.productId} - {item.productName} - {item.portion}
        </strong>
      </p>
      <Button type='default' style={{ marginLeft: 3, marginRight: 3 }} onClick={showCancelModal}>
        Annuleren
      </Button>
      <Button
        type='default'
        style={{ marginLeft: 3, marginRight: 3 }}
        onClick={showUpdateQuantityModal}
      >
        Aantal aanpassen
      </Button>

      <Modal
        title={`Annuleren | ${item.quantity}x ${item.productId} - ${item.productName} - ${item.portion}`}
        visible={isCancelModalVisible}
        onOk={handleCancelOk}
        onCancel={() => setIsCancelModalVisible(false)}
        okText='Opslaan'
        cancelText='Annuleren'
        confirmLoading={isSaving}
      >
        <p>Weet je zeker dat je dit wilt annuleren?</p>
      </Modal>

      <Modal
        title={`Aantal aanpassen | ${item.productName}`}
        visible={isUpdateQuantityModalVisible}
        onOk={handleUpdateQuantityOk}
        onCancel={() => setIsUpdateQuantityModalVisible(false)}
        okText='Opslaan'
        cancelText='Annuleren'
        confirmLoading={isSaving}
      >
        <p>Huidige hoeveelheid: {item.quantity}</p>
        <InputNumber min={1} value={newQuantity} onChange={(value) => setNewQuantity(value || 1)} />
      </Modal>
    </div>
  );
};

export { OrderEditItemFormComponent };
